module.exports = __webpack_public_path__ + "img/empty.ac197582.png";